import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import './ConflictPair.scss'
import { ReactComponent as CircleCrossIcon } from '../../../../assets/img/icons/circle-cross.svg'

// The shared "fact ⊗ fact" conflict row: two fact labels separated by a red
// circle-cross. Used both in the notification-center detail (compact, with
// clickable labels that jump to the fact) and in the set-time fact-conflict
// modal (plain labels).
const Side = ({ side }) => {
  if (side.onClick) {
    return (
      <button
        type="button"
        className="ConflictPair-Label ConflictPair-Label--clickable"
        onClick={side.onClick}
      >
        {side.label}
      </button>
    )
  }
  return <span className="ConflictPair-Label">{side.label}</span>
}

const sideShape = PropTypes.shape({
  label: PropTypes.node.isRequired,
  onClick: PropTypes.func,
})

Side.propTypes = {
  side: sideShape.isRequired,
}

const ConflictPair = ({ left, right, compact }) => (
  <div className={classNames('ConflictPair', { 'ConflictPair--compact': compact })}>
    <Side side={left}/>
    <span className="ConflictPair-Icon" aria-hidden="true">
      <CircleCrossIcon/>
    </span>
    <Side side={right}/>
  </div>
)

ConflictPair.propTypes = {
  left: sideShape.isRequired,
  right: sideShape.isRequired,
  /** compact typography for the narrow notification-center panel. */
  compact: PropTypes.bool,
}

export default ConflictPair
